import { render, staticRenderFns } from "./NotificationSettingsBase.vue?vue&type=template&id=438095cd&scoped=true"
import script from "./NotificationSettingsBase.vue?vue&type=script&lang=js"
export * from "./NotificationSettingsBase.vue?vue&type=script&lang=js"
import style0 from "./NotificationSettingsBase.vue?vue&type=style&index=0&id=438095cd&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438095cd",
  null
  
)

export default component.exports